var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToggole(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "toggole"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29374",
    "data-name": "Rectangle 29374",
    width: 21,
    height: 18,
    fill: "#6c757d",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_706",
    "data-name": "Mask Group 706",
    clipPath: "url(#toggole)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_19_",
    "data-name": "svgexport-6 (19)",
    transform: "translate(0 0.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M24.5,12.833v2.333H3.5V12.833Z",
    transform: "translate(-3.5 -5.833)",
    fill: "#6c757d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy",
    d: "M24.5,5.833V8.167H3.5V5.833Z",
    transform: "translate(-3.5 -5.833)",
    fill: "#6c757d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-2",
    d: "M24.5,19.833v2.333H3.5V19.833Z",
    transform: "translate(-3.5 -5.833)",
    fill: "#6c757d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggole);
export default __webpack_public_path__ + "static/media/toggole.ba267fe28efc9c8239fceb26d77fbddc.svg";
export { ForwardRef as ReactComponent };